import React from 'react';
import { searchTileType } from '../../../../constants';
import ContentTile from './content-tile';
import CourseTile from './course-tile';
import EventTile from './event-tile';

const SearchTile = (props) => (
  props.type === searchTileType.Course ?
    <CourseTile {...props} /> :
    props.type === searchTileType.Event ?
      <EventTile {...props} /> :
      <ContentTile {...props} />
)

export default SearchTile;


// WEBPACK FOOTER //
// ./src/containers/pages/app/partials/search-tile.js